import { type FieldValues } from 'react-hook-form';
import { reachAndResolve } from 'yup';
import { type IFormAugmentedContext } from '../form/augmented/FormAugmentedContext.tsx';

/**
 * Risolve lo schema yup augmentato per il campo `name` dati i valori
 * correnti del form. Ritorna `null` se la risoluzione fallisce (es.
 * path non raggiungibile per condizioni dinamiche).
 */
export function getAugmentedSchema(
  augmented: IFormAugmentedContext,
  values: FieldValues,
  name: string,
) {
  try {
    // getContext(values) sceglie internamente il context corretto: quello
    // risolto sui valori correnti quando disponibile, altrimenti il
    // validationContext statico.
    const context = augmented.resolvedStore.getContext(values);
    return reachAndResolve(augmented.schema, name, values, context);
  } catch (e) {
    return null;
  }
}
